<template>
  <div class="home" id="home">
    <Header :menu-at="500" :headerTitle="'Feuerwehr Pfaffenhofen'"/>
    <div class="container-fluid main-background">
      <div class="container">
        <div class="main-content">
        <div class="navigation-large">
          <p class="title">
            <font-awesome-icon icon="bars" />
            Navigation
          </p>
          <ul class="navigation-list">
            <li class="space"></li>
            <li class="active">Home</li>
            <li><router-link to="einsatz">Einsätze</router-link></li>
          <li><router-link to="aktuelles">Aktuelles</router-link></li>
            <li class="space"></li>
            <li v-scroll-to="{ element: '#contact', duration: 500 }">Kontakt</li>
            <li class="space"></li>
            <li><router-link to="fahrzeug">Fahrzeuge</router-link></li>
            <li><router-link to="group">Mannschaft</router-link></li>
            <li><router-link to="jugend">Jugendgruppe</router-link></li>
            <li><router-link to="standort">Standort</router-link></li>
            <li class="space"></li>
          </ul> 
        </div>
        <div class="brand">
          <div class="header">
            <img src="/ffp_logo.png" unselectable="on">
            <p class="greetings">
              Hier finden Sie Informationen rund um die Freiwillige Feuerwehr 
              aus dem schwäbischen Pfaffenhofen an der Roth. 
              <span class="more">
                Lernen Sie unsere Aufgaben und Ausrüstung kennen und 
                informieren Sie sich vom Verhalten beim Brandfall bis 
                hin zur Entstehungsgeschichte unserer Wehr.
              </span>
            </p>
            <div class="btn-group">
              <button class="btn-tour" v-scroll-to="{ element: '#about', duration: 500 }">
                Mehr zu Uns &nbsp; &nbsp; <font-awesome-icon icon="arrow-down" />
              </button>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>

    <div class="seperator"></div>
    <HomeOperations />
    <HomePosts />
    <HomeContact />
    <HomeAbout />
    <!-- 
    <Experimental />
     -->
    <Footer />
    <Scroll2Top />
    <cookie-law theme="blood-orange" buttonText="Akzeptieren" buttonDecline="true" buttonDeclineText="Ablehnen">
      <div slot="message">
        Diese Website verwendet Cookies um Ihnen ein möglichst gute Serviceangebot anzubieten. Wenn Sie diese Website nutzen stimmen Sie der Verwendung von Cookies zu. 
      </div>
      <button class="skew"><span>Ignore me</span></button>
    </cookie-law> 
  </div>
</template>

<script>
import HelloWorld from '@/components/HelloWorld.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Navbar from '@/components/NavBar.vue'
import HomeOperations from '@/components/HomeOperations.vue'
import HomeContact from '@/components/HomeContact.vue'
import HomeAbout from '@/components/HomeAbout.vue'
import HomePosts from '@/components/HomePosts.vue'
import Experimental from '@/components/Experimental.vue'
import Scroll2Top from '@/components/Scroll2Top.vue'
import CookieLaw from 'vue-cookie-law'

export default {
  name: 'home',
  components: {
    HelloWorld, Header, Navbar, HomeOperations, Experimental,
    HomeContact, HomeAbout, HomePosts , Footer, Scroll2Top, CookieLaw
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/theme.scss";

.home {
  background: $light-0;
}

.main-background {
  //background: #3f3f3f;
  background: url('/hero_background_3.png');
  background-size: cover;
  background-position-y: 40%;
  padding-bottom: 120px;
  padding-top: 30px;
  margin-top: 50px;
}

.main-content {
  display: flex;
  align-items: flex-start;
}

.navigation-large {
  background: $light-0;
  width: 250px;
  margin-top: 100px;
  display: none;
  flex-shrink: 0;
  border-radius: 4px;

  @include desktop {
    display: block;
  }

  .title {
    padding: 5px 10px;
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 16px;

    svg {
      margin-right: 5px;
    }
  }

  ul {
    background: $light-1;
    box-shadow: inset $shadow-light;
    list-style: none;
    padding: 0px;
  }

  li {
    cursor: pointer;
    border-top: 1px solid darken($light-0, 15%);
    padding: 10px 20px;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 16px;
    opacity: 0.7;
    text-align: center;

    &:first-child {
      border: none;
    }

    &:hover {
      background: $light-0;
      color: $primary-0;
      opacity: 0.9;
    }
  }

  .space {
    padding: 3px;
    background: darken($light-0, 15%);
    cursor: default;

    &:hover {
      background: darken($light-0, 15%);
      opacity: 0.7;
    }
  }

  .active {
    background: $light-0;
    color: $primary-0;
    opacity: 0.9;
    cursor: default;
  }

  a {
    text-decoration: none;
    color: black;

    &:hover {
      color: $primary-0;
      transition: 0.05s;
    }
  }
  
}

.brand {

  margin: 20px 20px 0px 20px;

  img {
    width: 90%;
      
    display: block;
    margin-left: auto;
    margin-right: auto;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    pointer-events: none;

    @include tablet {
      width: 70%;
      margin-bottom: 50px;
    }

    @include desktop {
      margin-top: -50px;
      width: 50%;
      margin-bottom: 20px;
    }

  }

  @include desktop {
    margin: 180px 0 0px 0px;
  }

  @include max {
     margin: 180px 0 0px 100px;
  }

  .header {
    margin-left: 20px;
  }

  h1 {
    font-size: 16px;
    margin-bottom: -10px;

    @include mini {
      font-size: 32px;
      margin-bottom: -30px;
    }
  }

  h2 {
    font-size: 20px;

    @include mini {
      font-size: 40px;
    }
  }

  .more {
    display: none;

    @include tablet {
      display: inline;
    }
  }

  p {
    opacity: 0.7;

    display: none;

    @include tablet {
      display: inline;
    }
  }

  p {
    color: $light-1;
  }

  h1, h2 {
    color: $light-1;
  }

  .btn-tour {
    display: none;
    padding: 20px 40px;
    border-radius: 12px;
    box-shadow: $shadow-medium;
    border: none;
    color: $light-0;
    font-size: 16px;
    text-transform: uppercase;
    background: linear-gradient(to right, lighten($primary, 5%) 0%, #e40613 50%, $primary-0 100%);
    
    background-size: 500%;
    font-weight: 700;
    transition: 0.5s;
    cursor: pointer;
    animation: gradient 4s infinite;

    @include tablet {
      display: block;
      margin: 30px auto 0 auto;
    }
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 
  }
  100% {
    background-position: 0% 50%;
  }
}

.seperator {
  height: 6px;
  background: linear-gradient(to right,$light-1 10%, $primary-0 50%, $light-1 90%)
}

.Cookie--blood-orange {
  background: $dark;
}
</style>